import(/* webpackMode: "eager" */ "/usr/src/app/client-portal/src/app/[lang]/onboarding/layout.tsx")